const { getDateInFormat, getDateInIso } = require('../../utils/Dates');
const _ = require('lodash');

const getBookingObject = (booking) => {
    if (!booking) {
        return;
    }

    const check_in = _.get(booking, 'deal.details.check_in') || booking.check_in;
    const check_out = _.get(booking, 'deal.details.check_out') || booking.check_out;
    const cancellation_date =
        _.get(booking, 'deal.dca.dealIsFullyRefundableTill') ||
        _.get(booking, 'deal.dca.refundableTillDate');
    const rooms = booking.rooms || _.get(booking, 'deal.details.room_count');
    const guests = booking.guests || _.get(booking, 'deal.details.guest_count');
    const nights = booking.nights || _.get(booking, 'deal.details.nights');
    const total_price =
        booking.price ||
        _.get(booking, 'deal.cheapopoPricing.cheapopoTotalPrice') ||
        _.get(booking, 'deal.totalPrice');
    const price_per_night =
        _.get(booking, 'deal.cheapopoPricing.pricePerNight') ||
        _.get(booking, 'deal.pricePerNight');
    const currency =
        _.get(booking, 'deal.cheapopoPricing.currency') ||
        _.get(booking, 'deal.currency') ||
        _.get(booking, 'payment.currency');
    const payment_type = _.get(booking, 'payment.payment_type');
    const order_date =
        _.get(booking, 'created_at') ||
        _.get(booking, 'created_at_date') ||
        _.get(booking, 'order_date');
    const room_name =
        _.get(booking, 'deal.room') ||
        booking.roomDescription ||
        _.get(booking, 'deal.details.room_description_original');
    const points_provider = _.get(booking, 'payment.loyalty.points_provider');
    const points_spent = _.get(booking, 'payment.loyalty.points');
    const transaction_cash_value_of_points = _.get(booking, 'payment.loyalty.points_in_currency');
    const total_price_in_usd =
        _.get(booking, 'deal.cheapopoPricing.totalPriceInUsd') ||
        _.get(booking, 'deal.cheapopoPricing.total_price_in_usd');
    const output_currency_to_usd_exchange_rate =
        _.get(booking, 'deal.cheapopoPricing.outputCurrencyToUsdExchangeRate') ||
        _.get(booking, 'deal.cheapopoPricing.output_currency_to_usd_exchange_rate');

    return {
        ...(booking.id && { reservation_id: booking.id }),
        ...((booking.childrenAges || _.get(booking, 'deal.details.children_ages')) && {
            children_ages: booking.childrenAges || _.get(booking, 'deal.details.children_ages'),
        }),
        ...(rooms && { rooms }),
        ...(guests && { guests }),
        ...(nights && { nights }),
        ...(price_per_night && { price_per_night }),
        ...(total_price && { total_price }),
        ...(total_price && { total_value: total_price }),
        ...(room_name && { room_name }),
        ...(booking.roomDescription && { room_description: booking.roomDescription }),
        ...(booking.short_id && { short_id: booking.short_id }),
        ...(currency && { currency }),
        ...(payment_type && { payment_type }),
        ...(points_provider && { points_provider }),
        ...(points_spent && { points_spent }),
        ...(transaction_cash_value_of_points && { transaction_cash_value_of_points }),
        ...(total_price_in_usd !== undefined && total_price_in_usd !== null && { total_price_in_usd }),
        ...(output_currency_to_usd_exchange_rate !== undefined &&
            output_currency_to_usd_exchange_rate !== null && { output_currency_to_usd_exchange_rate }),
        ...(order_date && { order_date: getDateInFormat(order_date) }),
        ...(check_in && { check_in: getDateInFormat(check_in) }),
        ...(check_out && { check_out: getDateInFormat(check_out) }),
        ...(check_in && { check_in_date: getDateInIso(check_in) }),
        ...(check_out && { check_out_date: getDateInIso(check_out) }),
        ...(cancellation_date && { cancellation_date: getDateInFormat(cancellation_date) }),
    };
};

module.exports = {
    getBookingObject,
};
